import { render, staticRenderFns } from "./prices.vue?vue&type=template&id=981bd738&scoped=true"
import script from "./prices.vue?vue&type=script&lang=js"
export * from "./prices.vue?vue&type=script&lang=js"
import style0 from "./prices.vue?vue&type=style&index=0&id=981bd738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981bd738",
  null
  
)

export default component.exports